module.exports = __webpack_public_path__ + "img/5ac_09.9a53c395.gif";